import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import {
  ActiveProductionOrder,
  ArticleClassification,
  ProducedMaterialType,
  Quantity,
  RunPhaseType,
  RunSubPhaseType
} from 'chronos-core-client';
import { isNil } from 'ramda';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ActiveOrderStore } from './active-order.store';

@Injectable({
  providedIn: 'root'
})
export class ActiveOrderQuery extends Query<ActiveProductionOrder> {
  public activeOrder$: Observable<ActiveProductionOrder> = this.select().pipe(map((entity) => this.productionOrderOrNull(entity)));
  public activeOrderPhase$: Observable<RunPhaseType> = this.select((entity) => entity.runPhaseType);
  public activeOrderSubPhase$: Observable<RunSubPhaseType> = this.select((entity) => entity.runSubPhaseType);
  public activeOrderId$: Observable<number> = this.select((entity) => entity.productionOrderId);
  public areKpisConfirmed$: Observable<boolean> = this.select((entity) => entity.areKpisConfirmed);
  public isQaHistoryConfirmed$: Observable<boolean> = this.select((entity) => entity.isQaHistoryConfirmed);
  public isQaHistoryConfirmedAutomatically$: Observable<boolean> = this.select((entity) => entity.isQaHistoryConfirmedAutomatically);
  public productionModeManual$: Observable<string> = this.select((entity) => entity.productionModeManual);
  public operationName$: Observable<string> = this.select((entity) => entity.operationName);
  public isQaToolCheckoutConfirmed$: Observable<boolean> = this.select((entity) => entity.isQaToolCheckoutConfirmed);
  public aqlSampleQuantity$: Observable<Quantity> = this.select((entity) => entity.aqlSampleQuantity);
  public tgsSampleQuantity$: Observable<Quantity> = this.select((entity) => entity.tgsSampleQuantity);

  constructor(protected store: ActiveOrderStore) {
    super(store);
  }

  public getActiveOrderSubPhase(): RunSubPhaseType {
    return this.getValue().runSubPhaseType;
  }

  public selectRunPhaseStartCounter(): Observable<number | null> {
    return this.select((entity) => entity.runPhaseStartCounterValue ?? null);
  }

  public getActiveOrderId(): number {
    return this.getValue().productionOrderId;
  }

  public getActiveOrder(): ActiveProductionOrder {
    return this.productionOrderOrNull(this.getValue());
  }

  private productionOrderOrNull(entity: ActiveProductionOrder): ActiveProductionOrder | null {
    return !isNil(entity.productionOrderId) ? entity : null;
  }

  public getActiveOrderType(): ProducedMaterialType {
    return this.getValue().producedMaterialType;
  }

  public getActiveOrderStatus(): string {
    return this.getValue().status;
  }

  public getAqlQuantity(): Quantity {
    return this.getValue().aqlSampleQuantity;
  }

  public getTgsQuantity(): Quantity {
    return this.getValue().tgsSampleQuantity;
  }

  public isSampleDataEnabled(): boolean {
    return this.getValue().isSampleDataEnabled;
  }

  public getArticleClassification(): ArticleClassification {
    return this.getValue().articleClassification ?? ArticleClassification.Other;
  }
}
